module.exports = __webpack_public_path__ + "static/media/fiverr-2018.b18a9fee.png";